import React, {useReducer} from 'react';
import {SimpleStorageContext} from './simpleStorageContext';
import simpleStorageReducer from './simpleStorageReducer';
import clienteAxios from '../../config/axios';
import tokenAuth from '../../config/token';
import {
    SIMPLE_STORAGE_LOADING,
    SIMPLE_STORAGE_ERROR,
    SIMPLE_STORAGE_IMAGES_FETCH,
    SIMPLE_STORAGE_IMAGES_ADD,
    SIMPLE_STORAGE_IMAGES_DELETE,
    SIMPLE_STORAGE_VIDEOS_FETCH,
    SIMPLE_STORAGE_VIDEOS_ADD,
    SIMPLE_STORAGE_VIDEOS_DELETE
} from '../../types';

const SimpleStorageState = (props) => {

    const INITIAL_STATE = {
        images: [],
        videos: [],
        loading: false,
        error: null
    };

    const [state, dispatch] = useReducer(simpleStorageReducer, INITIAL_STATE);

    const fetchImages = async (idCasa, entityCode) => {
        dispatch({
            type: SIMPLE_STORAGE_LOADING
        });
        try {
            if(!localStorage.getItem('token')) return;
            tokenAuth(localStorage.getItem('token'));
            const response = await clienteAxios.get(`/simple-storage/images/${idCasa}?entityCode=${entityCode}`);
            const {data: {multimedia: imagenes}} = response;
            dispatch({
                type: SIMPLE_STORAGE_IMAGES_FETCH,
                payload: imagenes || []
            });
        } catch (error) {
            dispatch({
                type: SIMPLE_STORAGE_ERROR,
                payload: error.response?.data || 'Error al cargar imágenes'
            });
        }
    };

    const uploadImages = async (formData) => {
        dispatch({
            type: SIMPLE_STORAGE_LOADING
        });
        try {
            if(!localStorage.getItem('token')) return;
            tokenAuth(localStorage.getItem('token'));
            await clienteAxios.post('/simple-storage/images/varios', formData);
            dispatch({
                type: SIMPLE_STORAGE_IMAGES_ADD
            });
        } catch (error) {
            dispatch({
                type: SIMPLE_STORAGE_ERROR,
                payload: error.response?.data || 'Error al subir imágenes'
            });
            throw error;
        }
    };

    const deleteImage = async (id, name) => {
        dispatch({
            type: SIMPLE_STORAGE_LOADING
        });
        try {
            if(!localStorage.getItem('token')) return;
            tokenAuth(localStorage.getItem('token'));
            await clienteAxios.delete(`/simple-storage/images/${id}?name=${name}`);
            dispatch({
                type: SIMPLE_STORAGE_IMAGES_DELETE
            });
        } catch (error) {
            dispatch({
                type: SIMPLE_STORAGE_ERROR,
                payload: error.response?.data || 'Error al eliminar imagen'
            });
            throw error;
        }
    };

    const fetchVideos = async (idCasa, entityCode) => {
        dispatch({
            type: SIMPLE_STORAGE_LOADING
        });
        try {
            if(!localStorage.getItem('token')) return;
            tokenAuth(localStorage.getItem('token'));
            const response = await clienteAxios.get(`/simple-storage/videos/${idCasa}?entityCode=${entityCode}`);
            const {data: {videos}} = response;
            dispatch({
                type: SIMPLE_STORAGE_VIDEOS_FETCH,
                payload: videos || []
            });
        } catch (error) {
            dispatch({
                type: SIMPLE_STORAGE_ERROR,
                payload: error.response?.data || 'Error al cargar videos'
            });
        }
    };

    const addVideo = async (videoData) => {
        dispatch({
            type: SIMPLE_STORAGE_LOADING
        });
        try {
            if(!localStorage.getItem('token')) return;
            tokenAuth(localStorage.getItem('token'));
            await clienteAxios.post('/simple-storage/videos', videoData);
            dispatch({
                type: SIMPLE_STORAGE_VIDEOS_ADD
            });
        } catch (error) {
            dispatch({
                type: SIMPLE_STORAGE_ERROR,
                payload: error.response?.data || 'Error al agregar video'
            });
            throw error;
        }
    };

    const deleteVideo = async (id, name) => {
        dispatch({
            type: SIMPLE_STORAGE_LOADING
        });
        try {
            if(!localStorage.getItem('token')) return;
            tokenAuth(localStorage.getItem('token'));
            await clienteAxios.delete(`/simple-storage/videos/${id}?name=${name}`);
            dispatch({
                type: SIMPLE_STORAGE_VIDEOS_DELETE
            });
        } catch (error) {
            dispatch({
                type: SIMPLE_STORAGE_ERROR,
                payload: error.response?.data || 'Error al eliminar video'
            });
            throw error;
        }
    };

    return (
        <SimpleStorageContext.Provider
            value={{
                images: state.images,
                videos: state.videos,
                loading: state.loading,
                error: state.error,
                fetchImages,
                uploadImages,
                deleteImage,
                fetchVideos,
                addVideo,
                deleteVideo
            }}>
            {props.children}
        </SimpleStorageContext.Provider>
    );
};

export default SimpleStorageState;
